module.exports = __webpack_public_path__ + "static/img/engineering_icon_empty.3c20b96.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/engineering_icon_empty.png
// module id = 5gbg
// module chunks = 1